import * as React from "react";
import {Button} from "@mui/material";

interface IDeleteActionProps {
    onDelete(): void;
}

export const DeleteAction = ({onDelete}: IDeleteActionProps) => (
    <Button
        type="button"
        onClick={onDelete}
        variant="contained"
        color="error"
    >
        Delete
    </Button>
)
